"use client";
import * as React from 'react';

export function Table({ className = '', ...rest }: React.HTMLAttributes<HTMLTableElement>) {
  const cls = ['admin-table', className].filter(Boolean).join(' ');
  return <table className={cls} {...rest} />;
}
export const THead = (p: React.HTMLAttributes<HTMLTableSectionElement>) => <thead {...p} />;
export const TBody = (p: React.HTMLAttributes<HTMLTableSectionElement>) => <tbody {...p} />;
export const Tr = (p: React.HTMLAttributes<HTMLTableRowElement>) => <tr {...p} />;
export const Th = ({ className = '', ...rest }: React.ThHTMLAttributes<HTMLTableCellElement>) => (
  <th className={['text-xs uppercase tracking-wide text-muted-foreground', className].join(' ')} {...rest} />
);
export const Td = (p: React.TdHTMLAttributes<HTMLTableCellElement>) => <td {...p} />;

export default Table;
